

export const getCustomerMeterEventSummarys = async (
  url, 
  token, 
  meterId, 
  customerId,
  startTime,
  endTime,
) => {
  try {
    const result = await fetch(url + `/usage-based-billing/customer-meter-event-summary/?meterId=${meterId}&customerId=${customerId}&startTime=${startTime}&endTime=${endTime}`, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      // body: JSON.stringify({
      //   customerId: customerId,
      //   priceId: priceId,
      // }),
    })

    const resData = await result.json()

    // console.log('meterEventSummarys', resData);

    if (result.ok) {
      return resData;
    } else {
      throw new Error('something wrong');
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const createUsageBasedBilling = async (url, token, customerId, priceId) => {
  try {
    const result = await fetch(url + `/usage-based-billing`, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        customerId: customerId,
        priceId: priceId,
      }),
    })

    const resData = await result.json()

    console.log('createUsageBasedBilling', result, resData);

    if (result.ok) {
      return resData;
    } else {
      throw new Error('something wrong');
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const getCustomerSubscriptions = async (url, token, customerId, ) => {
    try {
      const result = await fetch(url + `/usage-based-billing/customer-subscriptions/?customerId=${customerId}`, {
        // method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
        }
      );

      const resData = await result.json();

      if (result.ok) {
        return resData;
      } else {
        throw new Error('something wrong');
      }

    } catch(err) {
      console.log(err);
      throw err;
    }
  };

export const getUsageBasedConfig = async (url, token, service) => {
    try {
      const result = await fetch(url + `/usage-based-billing/usage-based-config/?service=${service}`, {
        // method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
        }
      );

      const resData = await result.json();

      if (result.ok) {
        return resData;
      } else {
        throw new Error('something wrong');
      }

    } catch(err) {
      console.log(err);
      throw err;
    }
};
// export const cancelSubscription = async (url, token, subscriptionId) => {
//   try {
//     const result = await fetch(url + `/usage-based-billing/cancel-subscription`, {
//       method: 'PUT',
//       headers: {
//         Authorization: 'Bearer ' + token,
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//       },
//       body: JSON.stringify({
//         subscriptionId: subscriptionId,
//       }),
//     })

//     const resData = await result.json()

//     // console.log('createUsageBasedBilling', result, resData);

//     if (result.ok) {
//       return resData;
//     } else {
//       throw new Error('something wrong');
//     }
//   } catch (err) {
//     console.log(err);
//     throw err;
//   }
// };

// export const resumeSubscription = async (url, token, subscriptionId) => {
//   try {
//     const result = await fetch(url + `/usage-based-billing/resume-subscription`, {
//       method: 'PUT',
//       headers: {
//         Authorization: 'Bearer ' + token,
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//       },
//       body: JSON.stringify({
//         subscriptionId: subscriptionId,
//       }),
//     })

//     const resData = await result.json()

//     // console.log('createUsageBasedBilling', result, resData);

//     if (result.ok) {
//       return resData;
//     } else {
//       throw new Error('something wrong');
//     }
//   } catch (err) {
//     console.log(err);
//     throw err;
//   }
// };